export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: false,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    // {
    //   label: '进件编号',
    //   prop: 'businessCode',
    //   display: false,
    //   search: false,
    // },
    {
      label: '租赁人',
      prop: 'name',
      display: false,
      search: false,
    },
    {
      label: '资料名称',
      prop: 'dataName',
      display: false,
      search: false,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      display: false,
      search: false,
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    {
      label: '份数',
      prop: 'dataAmount',
      span: 24,
      display: false,
    },
    {
      label: '邮寄状态',
      prop: 'status',
      span: 24,
      display: false,
      formatter: (val, value) => {
        return value ? '未邮寄' : '已邮寄';
      },
    },
  ],
};
